import { formatDate } from "@/utils";
import polyglot from "@/utils/polyglot";
import { useFormikContext } from "formik";
import moment from "moment";

export function useFrequencyOptions() {
  const { values } = useFormikContext();
  const dayOfWeek = formatDate(values.start_date, "dddd");

  const getOccurrence = (date) => {
    const momentDate = moment(date);
    const weekInMonth = Math.ceil(momentDate.date() / 7);

    const lastDayOfMonth = momentDate.clone().endOf("month");
    const daysInMonth = lastDayOfMonth.date();
    const remainingDays = daysInMonth - momentDate.date();

    if (remainingDays < 7) {
      return 4;
    }

    return weekInMonth;
  };

  const getWday = (date) => {
    const momentDate = moment(date);
    return momentDate.locale("en").format("dddd").toLowerCase();
  };

  const occurrence = getOccurrence(values.start_date) || 1;
  const occurrenceKeys = [
    "frequency.occurrence.first",
    "frequency.occurrence.second",
    "frequency.occurrence.third",
    "frequency.occurrence.last",
  ];

  return [
    {
      id: "weekly",
      title: polyglot.t("frequency.weekly"),
      subtitle: polyglot.t("frequency.subtitles.on_day", { day: dayOfWeek }),
      values: { wday: getWday(values.start_date) },
    },
    {
      id: "biweekly",
      title: polyglot.t("frequency.biweekly"),
      subtitle: polyglot.t("frequency.subtitles.on_day", { day: dayOfWeek }),
      values: { wday: getWday(values.start_date) },
    },
    {
      id: "monthly_by_weekday",
      title: polyglot.t("frequency.monthly"),
      subtitle: polyglot.t(occurrenceKeys[occurrence - 1], { day: dayOfWeek }),
      values: { wday: getWday(values.start_date), wposition: occurrence },
    },
  ];
}
